import { OrderItemLabelPrintType } from "@/dto/template/OrderItemLabelTemplateDTO";

enum OrderItemLabelField {
    QUANTITY_WITH_PROPERTY = "quantityWithProperty",
}

export function isOrderItemLabelFieldSupported(fieldKey: string, printType: OrderItemLabelPrintType) {
    return !(
        printType === OrderItemLabelPrintType.QUANTITY &&
        fieldKey === OrderItemLabelField.QUANTITY_WITH_PROPERTY
    );
}

export default OrderItemLabelField;
